import React from 'react';

/**
 * Logo de PaySlip para la app: el MISMO lockup que usa la landing rediseñada
 * (recortado al contenido, transparente, con el wordmark incluido). Se prefiere
 * sobre el cuadro con icono del prototipo para que la marca sea idéntica dentro
 * y fuera de la aplicación.
 */
const LOGO = '/landing/logo-payslip-trim.png';

const Logo = ({ size = 30, className = '', style }) => (
  <img
    className={['a2-logo', className].filter(Boolean).join(' ')}
    src={LOGO}
    alt="PaySlip"
    style={{ height: size, width: 'auto', display: 'block', flexShrink: 0, ...style }}
  />
);

export default Logo;
